export default __webpack_public_path__ + "static/media/ic-favorites-selected.2d2286f4.svg";